import { defineStore } from "pinia"

import paginationConfigs from "@/consts/paginationConfigs"
import offersService from "@/services/offersService"
import { OfferListItem } from "@/types/offers.type"

interface Pagination {
  current?: number
  pageSize?: number
  total?: number
  [key: string]: any
}

interface State {
  offers: OfferListItem[]
  pagination: Pagination
  fetching: boolean
}

export const useSyncOffersBindingStore = defineStore("syncOffersBinding", {
  state: (): State => ({
    offers: [],
    pagination: {
      ...paginationConfigs.drafts
    },
    fetching: false
  }),

  actions: {
    async getOffers({ query = {} }: { query?: Record<string, any> } = {}) {
      this.fetching = true

      try {
        const response = await offersService.get({
          pageSize: 100,
          page: 1,
          query
        })

        const { results: offers = [] } = response.data

        this.offers = offers
        this.fetching = false

        return response.data
      } catch (e: any) {
        this.fetching = false
        return Promise.reject(e?.response?.data || {})
      }
    },

    clearState() {
      this.fetching = false
      this.offers = []
      this.pagination = {
        ...paginationConfigs.drafts
      }
    }
  }
})
